import React, { memo, ReactElement } from 'react'
import LibImage from '@sport1/react-elements/Image'
import Grid from '@sport1/react-elements/Grid'
import { PropsType } from '@sport1/react-elements/Types'
import { ResizeModes } from '../ImageInterfaces'
import { TestID } from '../../../utils/PropTypesDefinitions'

type AssetImageProps = Pick<PropsType, 'height' | 'width'> & {
    imageUrl: string
    resizeMode?: ResizeModes
    alt?: string
    blurRadius?: number
} & TestID

const AssetImage = ({
    imageUrl,
    resizeMode,
    width,
    height,
    alt,
    blurRadius = 0,
    testID,
}: AssetImageProps): ReactElement => {
    return (
        <Grid noExpand position="relative" testID={testID} height={height} width={width}>
            <LibImage
                src={imageUrl}
                width={width}
                height={height}
                resizeMode={resizeMode}
                alt={alt}
                blurRadius={blurRadius}
            />
        </Grid>
    )
}

export default memo(AssetImage)
